/* eslint-disable @typescript-eslint/explicit-module-boundary-types */
import React from 'react';
import {LabelPreview, WrapperItemPreview, WrapperExpanded, LabelPreviewExpanded} from './style';
import Icon from '../../../icon';

function PreviewData(props) {
    const {UITippy, use, data = {}, defaultDataPreview = '--', firstNode} = props;

    if (use === 'preview-data') {
        const content = data.preview || defaultDataPreview;

        return (
            <LabelPreview>
                <Icon type="icon-xlab-thunder" />
                <UITippy content={content}><div className="text">{content}</div></UITippy>
            </LabelPreview>
        );
    } else if (use === 'preview-data-expanded') {
        const details = data.details || [];

        if (details.length > 0) {

            return (
                <LabelPreviewExpanded firstNode={firstNode}>
                    {/* <WrapperItemPreview>
                    <span className="label">Label</span>:
                    <UITippy content={'121 1212'}><div className="text">121 1212</div></UITippy>
                </WrapperItemPreview>; */}
                    <WrapperExpanded>
                        {details.map(item => {
                            return (
                                <WrapperItemPreview key={item.label}>
                                    <span className="label">{item.label}</span>:
                                    <UITippy content={item.value}><div className="text">{item.value}</div></UITippy>
                                </WrapperItemPreview>
                            );
                        })}
                    </WrapperExpanded>
                </LabelPreviewExpanded>
            );
        } 
    }

    return null;
    
}

export default PreviewData;